import { useState, useEffect } from 'react';
import { Match } from '../types';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../config/firebase';
import { 
  collection, 
  addDoc, 
  deleteDoc, 
  doc, 
  query, 
  where, 
  onSnapshot,
  orderBy,
  Timestamp 
} from 'firebase/firestore';

export const useMatches = () => {
  const [matches, setMatches] = useState<Match[]>([]);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setMatches([]);
      return;
    }

    const q = query(
      collection(db, 'matches'),
      where('userId', '==', user.id),
      orderBy('date', 'desc')
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const matchesData: Match[] = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        matchesData.push({
          id: doc.id,
          ...data,
          date: data.date.toDate()
        } as Match);
      });
      setMatches(matchesData);
    });

    return () => unsubscribe();
  }, [user]);


  const addMatch = async (userDeckId: string, opponentDeck: string, formatId: string, result: 'win' | 'loss', date: Date) => {
    if (!user) return;

    try {
      await addDoc(collection(db, 'matches'), {
        userId: user.id,
        userDeckId,
        opponentDeck,
        formatId,
        result,
        date: Timestamp.fromDate(date)
      });
    } catch (error) {
      console.error('Error adding match:', error);
      throw error;
    }
  };

  const deleteMatch = async (matchId: string) => {
    try {
      await deleteDoc(doc(db, 'matches', matchId));
    } catch (error) {
      console.error('Error deleting match:', error);
      throw error;
    }
  };

  return {
    matches,
    addMatch,
    deleteMatch
  };
};